import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'inicio',
      component: DashboardLayout,
      children: [
        {
          path: '/inicio',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/diario/:dia_numero',
          name: 'diario',
          component: () => import('./views/Diario.vue')
        },
        {
          path: '/pesquisa',
          name: 'pesquisa',
          component: () => import('./views/Pesquisa.vue')
        },
        {
          path: '/calendario',
          name: 'calendario',
          component: () => import('./views/Calendario.vue')
        },
        {
          path: '/fale-conosco',
          name: 'faleconosco',
          component: () => import('./views/FaleConosco')
        }
      ]
    },
    {
      path: '*',
      name: 'not-found',
      component: DashboardLayout,
      children: [
        {
          path: '/*',
          name: 'not',
          component: () => import('./views/Dashboard.vue')
        }
      ]
    }
  ]
})
